import { useState, useEffect } from 'react';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { H4 } from 'foundations-components/transitional/components/H4';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { Small } from 'foundations-components/transitional/components/Small';
import { View } from 'foundations-components/components/View';
import { useMutation, useQuery } from 'data-fetching-client';
import { CREATE_DASHBOARD_BLUEPRINT, UPDATE_DASHBOARD_BLUEPRINT, GET_DASHBOARD_BLUEPRINT_BY_DASHBOARD, DASHBOARD_BLUEPRINT_BY_DASHBOARD_FIELD_NAME, CREATE_DASHBOARD_BLUEPRINT_FIELD_NAME } from '../../data/requests/dashboardBlueprints';
import { ReportActionsFloatingAlertStore } from 'reporting-action-components/shared/ReportActionsFloatingAlertStore';
// @ts-expect-error Untyped import
import { useHideDialog } from '../../dialog/ducks';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getBlueprintUrl = uuid => {
  return `${window.location.origin}/l/reports-dashboard/import/${uuid}`;
};
const ShareDashboardBlueprintDialog = ({
  dashboardId,
  dashboard
}) => {
  const {
    data: existingBlueprintData,
    loading: queryLoading
  } = useQuery(GET_DASHBOARD_BLUEPRINT_BY_DASHBOARD, {
    variables: {
      dashboardId
    }
  });
  const [blueprint, setBlueprint] = useState(null);
  useEffect(() => {
    const blueprintData = existingBlueprintData === null || existingBlueprintData === void 0 ? void 0 : existingBlueprintData[DASHBOARD_BLUEPRINT_BY_DASHBOARD_FIELD_NAME];
    if (blueprintData) {
      setBlueprint(blueprintData);
    }
  }, [existingBlueprintData]);
  const hideDialog = useHideDialog();
  const [createBlueprint, {
    loading: createLoading
  }] = useMutation(CREATE_DASHBOARD_BLUEPRINT, {
    onCompleted: data => {
      setBlueprint(data[CREATE_DASHBOARD_BLUEPRINT_FIELD_NAME]);
    },
    onError: () => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.dashboards.shareTemplate.error"
        }),
        type: 'danger'
      });
      hideDialog();
    }
  });
  const [updateBlueprint, {
    loading: updateLoading
  }] = useMutation(UPDATE_DASHBOARD_BLUEPRINT, {
    onCompleted: data => {
      setBlueprint(data.updateDashboardBlueprint);
    },
    onError: () => {
      ReportActionsFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.dashboards.shareTemplate.error"
        }),
        type: 'danger'
      });
    }
  });
  const renderGenerateOrCopyButton = () => {
    if (queryLoading) {
      return /*#__PURE__*/_jsx(LoadingSpinner, {});
    }
    if (blueprint !== null && blueprint !== void 0 && blueprint.uuid) {
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(CopyButton, {
          value: getBlueprintUrl(blueprint.uuid),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.dashboards.shareTemplate.copy"
          })
        }), /*#__PURE__*/_jsx(LoadingButton, {
          loading: updateLoading,
          use: "secondary",
          onClick: () => {
            updateBlueprint({
              variables: {
                dashboardId
              }
            }).catch(console.error);
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.dashboards.shareTemplate.update"
          })
        })]
      });
    }
    return /*#__PURE__*/_jsx(LoadingButton, {
      loading: createLoading,
      use: "primary",
      onClick: () => {
        createBlueprint({
          variables: {
            dashboardId
          }
        }).catch(console.error);
      },
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.dashboards.shareTemplate.create"
      })
    });
  };
  return /*#__PURE__*/_jsxs(Modal, {
    onEsc: hideDialog,
    width: 600,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      onClick: hideDialog
    }), /*#__PURE__*/_jsx(DialogHeader, {
      children: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.dashboards.shareTemplate.title"
        })
      })
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "reporting-action-components.dashboards.shareTemplate.description",
        options: {
          dashboardName: dashboard.get('name')
        }
      }), (blueprint === null || blueprint === void 0 ? void 0 : blueprint.updatedAt) && /*#__PURE__*/_jsx(View, {
        marginBlockStart: "400",
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-action-components.dashboards.shareTemplate.updatedAt",
            options: {
              date: I18n.moment.userTz(blueprint.updatedAt).format('lll z')
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [renderGenerateOrCopyButton(), /*#__PURE__*/_jsx(Button, {
        onClick: hideDialog,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-action-components.dashboards.shareTemplate.close"
        })
      })]
    })]
  });
};
export default ShareDashboardBlueprintDialog;